import { useAuth } from "@/Providers/Auth";
import { Button } from "@/shadcnComponents/ui/button";
import { useToast } from "@/shadcnComponents/ui/use-toast";
import { ArrowRight } from "lucide-react";
import { useEffect, useState } from "react";
import { FollowOtherCreators } from "../Influencer/MyNetwork/Follow";
import { useInfluencer } from "@/Providers/Influencer";
import { useStaticData } from "@/Providers/Data";

export const UserInfoPreExtension = ({ handleSubmit }) => {
  const { toast } = useToast();
  const influencerState = useInfluencer();
  const staticDataState = useStaticData();
  const authState = useAuth();

  const [currentStep, setCurrentStep] = useState(1);
  const [referCode, setReferCode] = useState(null);

  useEffect(() => {
    if (authState?.loggedUser?.refered_by) {
      // If user already has a referral in their profile, use that
      setReferCode(authState?.loggedUser?.refered_by);
    } else {
      // Check localStorage
      const storedReferralJSON = localStorage.getItem("anchors_collab_refer");

      // Handle both new JSON format and legacy string format
      if (storedReferralJSON) {
        try {
          // Try to parse as JSON (new format)
          const storedReferral = JSON.parse(storedReferralJSON);

          // Check if 24 hours have passed
          const now = Date.now();
          const hoursPassed =
            (now - storedReferral.timestamp) / (1000 * 60 * 60);

          if (hoursPassed < 24) {
            // Referral code is still valid
            setReferCode(storedReferral.code);
          } else {
            // Expired referral, clear it
            localStorage.removeItem("anchors_collab_refer");
            setReferCode(null);
          }
        } catch (e) {
          // This handles the case of old format (just the code without timestamp)
          // For backwards compatibility, we'll consider these as not expired
          localStorage.removeItem("anchors_collab_refer");
          setReferCode(storedReferralJSON);
        }
      } else {
        setReferCode(null);
      }
    }
  }, [authState]);

  const [fade, setFade] = useState(false);
  const [selectedWhatYouWillFind, setSelectedWhatYouWillFind] = useState<
    number[]
  >([]);
  const [WhatYouWillFindOptions, setWhatYouWillFindOptions] =
    useState<WhatYouWillFindOptionsItem[]>();
  const [influencerSourceOptions, setInfluencerSourceOptions] =
    useState<WhatYouWillFindOptionsItem[]>();
  const [selectedInfluencerSource, setSelectedInfluencerSource] = useState<
    number[]
  >([]);

  useEffect(() => {
    staticDataState
      ?.getNewDataFromType("WhatYouWillFindOptions")
      ?.then((data: WhatYouWillFindOptionsItem[]) =>
        setWhatYouWillFindOptions(data)
      );

    staticDataState
      ?.getNewDataFromType("influencerSourceOptions")
      ?.then((data: WhatYouWillFindOptionsItem[]) =>
        setInfluencerSourceOptions(data)
      );
  }, []);

  const handleNextStep = async () => {
    if (currentStep === 4) {
      if (selectedWhatYouWillFind?.length < 1) {
        toast({
          title: "Please select at least one option",
          description: "You need to select at least one option.",
          variant: "destructive",
        });
        return;
      }

      if (referCode?.length) {
        const savereferralcode = await influencerState?.SaveUserInfo({
          refered_code: referCode,
        });
        if (!savereferralcode?.success) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Inavlid Referral code",
          });
        }
      }

      const response = await influencerState?.updatePersonalInfo({
        selectedWhatYouWillFind,
      });
      if (response?.success) {
        setFade(true);
        setTimeout(() => {
          setCurrentStep(currentStep + 1);
          setFade(false);
        }, 300);
      }
    } else if (currentStep === 3) {
      if (selectedInfluencerSource?.length < 1) {
        toast({
          title: "Please select at least one option",
          description: "You need to select at least one option.",
          variant: "destructive",
        });
        return;
      }

      const response = await influencerState?.updatePersonalInfo({
        selectedInfluencerSource,
      });
      if (response?.success) {
        setFade(true);
        setTimeout(() => {
          setCurrentStep(currentStep + 1);
          setFade(false);
        }, 300);
      }
    } else {
      setFade(true);
      setTimeout(() => {
        setCurrentStep(currentStep + 1);
        setFade(false);
      }, 300);
    }
  };

  const handlePreviousStep = () => {
    setFade(true);
    setTimeout(() => {
      setCurrentStep(currentStep - 1);
      setFade(false);
    }, 300);
  };

  const handleSelectWhatWillYouFind = (id) => {
    setSelectedWhatYouWillFind((prev) => {
      if (prev?.includes(id)) {
        return prev.filter((i) => i !== id);
      } else {
        if (prev?.length < 3) {
          return [...prev, id];
        } else {
          toast({
            title: "Maximum selection reached",
            description: "You can only select a maximum of 3 options.",
            variant: "destructive",
          });
          return prev;
        }
      }
    });
  };

  const handleSelectInfluencerSource = (id, isOther = false) => {
    if (isOther) {
      const prev = selectedInfluencerSource;
      prev[1] = id;
      setSelectedInfluencerSource(prev);
    } else {
      setSelectedInfluencerSource([id]);
    }
  };
  console.log(selectedInfluencerSource);

  return (
    <>
      <div
        className={`w-full flex flex-col items-center md:justify-center ${
          currentStep > 3 ? "" : "min-h-screen h-screen"
        } `}
      >
        <div
          className={`w-full  items-start justify-center relative ${
            currentStep > 3
              ? "py-[25px] md:py-[70px] md:px-[10%]"
              : "md:h-[70%] h-[90%]  md:px-[25%] px-[20px]"
          } `}
        >
          {currentStep <= 4 && (
            <div
              className={`w-full h-[100%] md:h-[90%] items-center justify-center flex flex-col gap-10 md:mt-[-50px]`}
            >
              <div
                className={`flex w-full h-full justify-center items-center  transition-opacity duration-300 ${
                  fade ? "opacity-0" : "opacity-100"
                }`}
              >
                {currentStep === 1 && <PreExtensionFirstSection />}
                {currentStep === 2 && <PreExtensionSecondSection />}
                {currentStep === 3 && (
                  <PreExtensionThirdSection
                    influencerSourceOptions={influencerSourceOptions}
                    selectedInfluencerSource={selectedInfluencerSource}
                    handleSelectInfluencerSource={handleSelectInfluencerSource}
                  />
                )}

                {currentStep === 4 && (
                  <PreExtensionFourthSection
                    WhatYouWillFindOptions={WhatYouWillFindOptions}
                    selectedWhatYouWillFind={selectedWhatYouWillFind}
                    onSelect={(id) => handleSelectWhatWillYouFind(id)}
                  />
                )}
              </div>

              {/* Ensure that the buttons are always positioned at the bottom */}
              <div
                className={` ${
                  currentStep < 4 ? "absolute bottom-0 left-0 " : ""
                }w-full  flex justify-end px-[20px] md:px-[25%] items-center`}
              >
                <div className="flex gap-[35px] justify-end w-full">
                  {currentStep > 1 && (
                    <Button
                      onClick={handlePreviousStep}
                      variant="outline"
                      className="gap-2.5 bg-inherit text-white"
                    >
                      Back
                    </Button>
                  )}
                  <Button
                    onClick={handleNextStep}
                    variant="destructive"
                    className="bg-[#DC2627] gap-2.5"
                  >
                    Continue
                    <ArrowRight size={18} />
                  </Button>
                </div>
              </div>
            </div>
          )}
          {currentStep === 5 && (
            <FollowOtherCreators handleSubmit={handleSubmit} />
          )}
        </div>
      </div>
    </>
  );
};

const PreExtensionFirstSection = () => {
  const authState = useAuth();

  return (
    <div className="flex h-max flex-col-reverse md:flex-row items-start md:items-center gap-5 md:gap-12 p-[10px] md:px-[20px] md:py-[12px] border rounded-lg border-solid border-[#292F35]">
      <div className="flex md:w-[25%] md:min-w-[120px] md:flex-col items-center gap-5 md:gap-1.5">
        <img
          className="w-[60px] h-[60px] md:w-[120px] md:h-[120px] rounded-sm"
          src="https://anchors-assets.s3.ap-south-1.amazonaws.com/aesha_anchors.png"
          alt=""
        />
        <p className="flex flex-col md:items-center justify-center text-[#A6A6A6] md:text-center text-xs not-italic font-bold leading-[normal]">
          <span>Aesha</span>
          <span>Co-founder, anchors</span>
        </p>
      </div>
      <div className="flex w-full flex-col flex-wrap items-start gap-3.5">
        <span className="text-slate-200 text-base not-italic font-semibold leading-6">
          Hi, {authState?.loggedUser?.name} 👋
        </span>
        <p className="text-[#A6A6A6] text-xs not-italic font-normal leading-5 flex flex-col gap-[20px]">
          <span>
            I wanted to personally welcome you. We’ve been working on this
            platform for nearly a year now, for creators like you, to grow,
            collab, and make money doing what you love. As you explore, you’ll
            discover gems tucked away in corners of this platform, like a Media
            Kit that shows off your value, real collaboration examples from
            fellow creators, and so much more.
          </span>
          <span>It’s all here to help you level up.</span>
          <span>
            So take a look around, explore, and if you need anything, I’m just
            an email away.
          </span>
        </p>
      </div>
    </div>
  );
};
const PreExtensionSecondSection = () => {
  return (
    <div className="flex items-center p-[10px] md:px-[20px] md:py-[12px] border rounded-lg border-solid border-[#292F35]">
      <div className="flex w-full flex-col flex-wrap items-start gap-3.5">
        <span className="text-slate-200 text-base not-italic font-semibold leading-6">
          💡 Why anchors exists?
        </span>
        <p className="text-[#A6A6A6] text-xs not-italic font-normal leading-5 flex flex-col gap-[20px]">
          <span>
            It’s very simple - the current way things are done is broken.
          </span>
          <span>
            Creators are struggling just as much as brands are, if not more.
            It’s a lose-lose situation, whichever way you look at it. We exist
            to fix it.
          </span>
          <span>
            We exist so creators won’t feel alone in this journey of content
            creation - right from starting out, to growing, to monetizing from
            it, to giving back to the community. We’re there with you at every
            step of the way.
          </span>
        </p>
      </div>
    </div>
  );
};
const PreExtensionFourthSection = ({
  WhatYouWillFindOptions,
  selectedWhatYouWillFind,
  onSelect,
}: {
  WhatYouWillFindOptions: WhatYouWillFindOptionsItem[];
  selectedWhatYouWillFind: number[];
  onSelect: (number) => void;
}) => {
  return (
    <div className="md:px-[25%] px-[20px]">
      <div
        style={{ scrollbarWidth: "none" }}
        className="flex h-[100%] overflow-auto w-full flex-col items-center gap-2 p-[10px] md:px-[20px] md:py-[12px] border rounded-lg border-solid border-[#292F35] "
      >
        <div className="flex w-full flex-col gap-1  ">
          <span className="text-slate-200 text-base not-italic font-semibold leading-6">
            What will you find here?
          </span>
          <span className="text-[#A6A6A6] text-sm not-italic font-normal leading-6">
            (select any 3 that excite you)
          </span>
        </div>
        <div className="flex flex-col gap-[10px] w-full ">
          {WhatYouWillFindOptions?.map((item, index) => (
            <div
              key={index}
              onClick={() => onSelect(item?._id)}
              className={`flex items-center gap-6 self-stretch flex-grow border p-2.5 cursor-pointer rounded-[10px] border-solid ${
                selectedWhatYouWillFind?.includes(item?._id)
                  ? "border-[#DC2627]"
                  : "border-[#292F35]"
              } `}
            >
              <div className="flex min-w-[60px] min-h-[60px] justify-center items-center bg-[rgba(38,38,38,0.50)] p-2.5 rounded-[10px]">
                <img src={item?.icon} alt="" />
              </div>
              <div className="flex flex-col">
                <span className="text-slate-200 text-xs md:text-sm not-italic font-semibold leading-6">
                  {item?.title}
                </span>
                <span className="text-[#A6A6A6] text-xs not-italic font-normal leading-5">
                  {item?.description}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
interface WhatYouWillFindOptionsItem {
  _id: number;
  icon: string;
  title: string;
  description: string;
}

const PreExtensionThirdSection = ({
  influencerSourceOptions,
  selectedInfluencerSource,
  handleSelectInfluencerSource,
}: {
  influencerSourceOptions: WhatYouWillFindOptionsItem[];
  selectedInfluencerSource: number[];
  handleSelectInfluencerSource: (value, isOther) => void;
}) => {
  const [otherSource, setOtherSource] = useState<string>("");
  const otherOptionId = influencerSourceOptions?.find(
    (item) => item?.title === "Other"
  )?._id;

  useEffect(() => {
    if (otherSource?.length > 0) {
      handleSelectInfluencerSource(otherSource, true);
    }
  }, [otherSource, handleSelectInfluencerSource]);

  return (
    <div className="flex items-center p-[10px] md:px-[20px] md:py-[12px] border rounded-lg border-solid border-[#292F35]">
      <div className="flex w-full flex-col flex-wrap items-start gap-3.5">
        <h1 className="text-lg text-slate-200 font-bold mb-0.5">
          How did you hear about us?
        </h1>
        <p className="text-[#A6A6A6] text-xs mb-4">(Choose one option)</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {influencerSourceOptions?.map((option, index) => (
            <div key={index}>
              <div
                onClick={() => handleSelectInfluencerSource(option?._id, false)}
                className={`w-full h-[70px] text-left p-3 rounded-md border ${
                  selectedInfluencerSource?.includes(option?._id)
                    ? "border-red-500"
                    : "border-gray-800"
                } bg-[#151515] hover:bg-[#0a0a0a] transition-colors cursor-pointer flex items-center`}
              >
                <div className="flex items-start">
                  <div className="mt-0.5 mr-2">
                    <div
                      className={`w-4 h-4 rounded-full border ${
                        selectedInfluencerSource?.includes(option?._id)
                          ? "border-red-500"
                          : "border-gray-600"
                      } flex items-center justify-center`}
                    >
                      {selectedInfluencerSource?.includes(option?._id) && (
                        <div className="w-2 h-2 rounded-full bg-red-500"></div>
                      )}
                    </div>
                  </div>
                  <div>
                    <h3 className="font-medium text-slate-200 text-sm">
                      {option?.title}
                    </h3>
                    <p className="text-gray-400 text-xs">
                      {option?.description}
                    </p>
                  </div>
                </div>
              </div>

              {selectedInfluencerSource?.includes(otherOptionId) &&
                option?._id === otherOptionId && (
                  <div className="mt-1.5 p-2 bg-[#151515] rounded-md ml-6">
                    <input
                      type="text"
                      value={otherSource}
                      onChange={(e) => setOtherSource(e.target.value)}
                      placeholder="Please specify..."
                      className="w-full bg-[#151515] border border-gray-800 rounded text-xs px-2 py-1.5 text-white placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-red-500 focus:border-red-500"
                    />
                  </div>
                )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
